module.exports = __webpack_public_path__ + "img/record-icon.a2e82fba.png";